import { FILTER_ITEM_CODE, GET_LIST_ITEM_NAME_SUCCESS, CHANGE_ITEM_NAME } from '../actions/getListItemName';

const initState = {
    listItemName: [],
    filterItemCode: [],
    isLoading: false
}

export default (state = initState, action) => {
    switch (action.type) {
        case GET_LIST_ITEM_NAME_SUCCESS:
            return {
                listItemName: action.payload.data.data.result.AllItemNameResults,
                filterItemCode: action.payload.data.data.result.AllItemNameResults,
                isLoading: false
            }

        case FILTER_ITEM_CODE:
            return {
                ...state,
                filterItemCode: action.payload
            }

        case CHANGE_ITEM_NAME: 
            return {
                ...state,
                isLoading: true
            }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/getListItemName.js